import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink, Outlet } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { signout } from "../../redux/firebaseState/api";
import LogoutModal from "../modals/Logout";

export type playerData = {
  playerData: [];
};
export const findPageTitle = (pageName: any) => {
  switch (pageName) {
    case '/AfterLogin/newsletter' : 
      return 'newsLetter'
    case '/AfterLogin/banner' : 
      return 'AddBanner'
    case '/AfterLogin/users' : 
      return 'UsersPage'
    case '/AfterLogin/leaderboard' : 
      return 'LeaderboardPage'
    case '/AfterLogin/winnerannouncement' : 
      return 'winnerannouncement'
    case '/AfterLogin/manualnotification' : 
      return 'manualnotification'
    case '/AfterLogin/editprivacypolicy' : 
      return 'editprivacypolicy'
    case '/AfterLogin/changepassword' : 
      return 'changepassword'
    // case '/AfterLogin/purchasehistory' : 
    //   return 'PurchaseHistoryPage'
      
    default:
      return "newsLetter";
  }
};
export default function SideLayoutComponent() {
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);

  const dispatch = useDispatch();
  const [childPage, setChildPage] = useState("");
  const location = useLocation();
  useEffect(() => {
    setChildPage(findPageTitle(location.pathname));
    if (childPage) {
      document.querySelectorAll(".nav-link")!.forEach((ele: any) => {
        ele.classList.remove("active");
      });
      document.getElementById(childPage)!.classList.add("active");
    }
  }, [location, childPage]);

  function handleClick(e: any) {
    e.preventDefault();
    window.open(
      "https://play.google.com/console/u/0/developers/6350789107840497487/app/4976299613973479140/user-feedback/reviews"
    );
    window.open(
      "https://appstoreconnect.apple.com/apps/6446239864/appstore/activity/ios/ratingsResponses"
    );
  }

  const handleOpenModal=()=>{
    console.log("handle open modal in if conditon")
    setLogoutModalOpen(true)
}


  return (
    <div id="layoutSidenav_nav">
      <nav
        className="sb-sidenav accordion sb-sidenav-dark"
        id="sidenavAccordion"
      >
        <div className="sb-sidenav-menu">
          <div className="nav pt-4">
            
            <NavLink className="nav-link " 
              to="/AfterLogin/newsletter" 
              id="newsLetter">
              Add Newsletter
            </NavLink>
            <NavLink className="nav-link " 
              to="/AfterLogin/banner" 
              id="AddBanner">
              Add Banner
            </NavLink>
            <NavLink className="nav-link " 
              to="/AfterLogin/users" 
              id="UsersPage">
              Users
            </NavLink>
            <NavLink className="nav-link " 
              to="/AfterLogin/leaderboard" 
              id="LeaderboardPage">
              Leaderboard
            </NavLink>
            <NavLink className="nav-link " 
              to="/AfterLogin/winnerannouncement" 
              id="winnerannouncement">
              Winner Announcement
            </NavLink>
            <NavLink className="nav-link " 
              to="/AfterLogin/manualnotification" 
              id="manualnotification">
             Manual Notification
            </NavLink>
            <NavLink className="nav-link " 
              to="/AfterLogin/editprivacypolicy" 
              id="editprivacypolicy">
              Privacy Policy
            </NavLink>
            <NavLink className="nav-link " 
              to="/AfterLogin/changepassword" 
              id="changepassword">
              Change Password
            </NavLink>
            {/* <NavLink className="nav-link " 
              to="/AfterLogin/purchasehistory" 
              id="PurchaseHistoryPage">
              Purchase History
            </NavLink> */}
            <div
              style={{ cursor: "pointer" }}
              className="nav-link "
              onClick={() => handleOpenModal()}
              id="Logout"
            >
              Logout
            </div>
            {logoutModalOpen &&  <LogoutModal setLogoutModalOpen={setLogoutModalOpen} />}

          </div>
        </div>
      </nav>
      <Outlet />
    </div>
  );
}
